export const businessRuleOptions = {
  amountTable: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  wageItemType: [
    { value: "1", label: "Provento" },
    { value: "2", label: "Desconto" },
  ],
  collectiveAgreementType: [
    { value: "1", label: "Acordo Coletivo de Trabalho (ACT)" },
    { value: "2", label: "Convenção Coletiva de Trabalho (CCT)" },
  ],
  applyCollectiveAgreementRules: [
    { value: "1", label: "Integral" },
    { value: "2", label: "Parcial" },
    { value: "3", label: "Não aplica" },
    { value: "4", label: "Outro" },
  ],
  vacationAdvanceDiscounts: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  vacationAverages: [
    { value: "1", label: "Conforme CCT|ACT" },
    { value: "2", label: "Conforme CLT" },
    { value: "3", label: "Outro" },
  ],
  vacationBenefits: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
    { value: "3", label: "Conforme CCT|ACT" },
    { value: "4", label: "Outro" },
  ],
  terminationDiscounts: [
    { value: "1", label: "Plano de Saúde" },
    { value: "2", label: "Plano Odontológico" },
    { value: "3", label: "Empréstimos" },
    { value: "4", label: "Outros" },
  ],
  loanDiscountPercentageTermination: [
    { value: "1", label: "30%" },
    { value: "2", label: "35%" },
    { value: "3", label: "Outros" },
  ],
  terminationAverages: [
    { value: "1", label: "Conforme CCT|ACT" },
    { value: "2", label: "Conforme CLT" },
    { value: "3", label: "Outro" },
  ],
  payrollHasInterns: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  internSalaryAdjustmentRule: [
    { value: "1", label: "Salário Mínimo" },
    { value: "2", label: "Conforme CCT|ACT" },
    { value: "3", label: "Outro" },
  ],
  internHasDeductions: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  internHasBenefits: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  interBenefitsCalculation: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  interPayrollProcessing: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  internFixedBenefit: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  internBenefitValue: [
    { value: "1", label: "Fixo" },
    { value: "2", label: "Dias Úteis (valor por dia)" },
  ],
  internProportionalCalcRule: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não, 30 dias" },
    { value: "3", label: "Conforme CCT|ACT" },
    { value: "4", label: "Outro, divide-se por" },
  ],
  payrollHasApprentices: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  apprenticeSalaryAdjustmentRule: [
    { value: "1", label: "Salário Mínimo" },
    { value: "2", label: "Conforme CCT|ACT" },
    { value: "3", label: "Outro" },
  ],
  apprenticeHasDeductions: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  apprenticeHasBenefits: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  apprenticeBenefitsCalculation: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  apprenticePayrollProcessing: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  apprenticeFixedBenefit: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  apprenticeBenefitValue: [
    { value: "1", label: "Fixo" },
    { value: "2", label: "Dias Úteis (valor por dia)" },
  ],
  apprenticeProportionalCalcRule: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não, 30 dias" },
    { value: "3", label: "Conforme CCT|ACT" },
    { value: "4", label: "Outro, divide-se por" },
  ],
  hasAutonomous: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  hasProLabore: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  proLaboreSalaryAdjustmentRule: [
    { value: "1", label: "Salário Mínimo" },
    { value: "2", label: "Conforme CCT|ACT" },
    { value: "3", label: "Outro" },
  ],
  proLaboreHasFgtsNoLink: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  payrollAnalyticalReportOrder: [
    { value: "1", label: "Nome" },
    { value: "2", label: "Centro de Custo" },
    { value: "3", label: "Matrícula" },
    { value: "4", label: "Consolidado (matriz|filial)" },
  ],
  payrollSyntheticReportOrder: [
    { value: "1", label: "Nome" },
    { value: "2", label: "Centro de Custo" },
    { value: "3", label: "Matrícula" },
    { value: "4", label: "Consolidado (matriz|filial)" },
  ],
  payrollNetReport: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  payrollNetReportExcel: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
    { value: "3", label: "Consolidado (matriz|filial)" },
  ],
  payrollAccountingSyntheticReportOrder: [
    { value: "1", label: "Nome" },
    { value: "2", label: "Centro de Custo" },
    { value: "3", label: "Matrícula" },
    { value: "4", label: "Consolidado (matriz|filial)" },
  ],
  hasDomesticEmployee: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  domesticEmployeeSalaryAdjustmentRule: [
    { value: "1", label: "Salário Mínimo" },
    { value: "2", label: "Conforme CCT|ACT" },
    { value: "3", label: "Outro" },
  ],
  domesticEmployeeWorkTimeControl: [
    { value: "1", label: "Manual" },
    { value: "2", label: "Eletrônico" },
  ],
  domesticEmployeeClosePeriod: [
    { value: "1", label: "16/15" },
    { value: "2", label: "21/20" },
    { value: "3", label: "26/25" },
    { value: "4", label: "Outro" },
  ],
  hasSpecificWageItems: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  hasCustomWageIncidences: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  amountIncomeType: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
  hasHazardPay: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  hasInsalubrityPay: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  discountAdditionalOnAbsence: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  proportionalRuleForDifferentMonthDays: [
    { value: "1", label: "Sim (*)" },
    { value: "2", label: "Não, divisor por 30 dias." },
  ],
  otherExclusiveRules: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
  ],
};
